<app-side-menu>
  <div class="traffic-fines-container">

    <div class="traffic-fines-card">
      <div class="fines-tabs">
        <button type="button" class="fines-tab" [class.active]="aba === 'lista'" (click)="aba = 'lista'">Multas</button>
        <button type="button" class="fines-tab" [class.active]="aba === 'sem-vinculo'" (click)="aba = 'sem-vinculo'">Sem vínculo no contrato</button>
      </div>

      <ng-container *ngIf="aba === 'lista'">
      <div class="filters-section">
        <div class="filters-fields-row">
          <div class="filter-group">
            <label class="form-label">Pesquisar por Cliente</label>
            <input type="text" class="form-control" [(ngModel)]="customerSearch" placeholder="Nome ou ID"
              (keyup.enter)="search()" />
          </div>

          <div class="filter-group">
            <label class="form-label">Placa</label>
            <input type="text" class="form-control" [(ngModel)]="vehiclePlate" placeholder="Ex.: ABC1D23"
              style="text-transform: uppercase" (keyup.enter)="search()" />
          </div>

          <div class="filter-group">
            <label class="form-label">Maior Valor</label>
            <input type="number" class="form-control" [(ngModel)]="minAmount" min="0" step="0.01"
              placeholder="Mín. R$ (≥)" (keyup.enter)="search()" />
          </div>

          <div class="filter-group">
            <label class="form-label">Data da Infração</label>
            <input type="date" class="form-control" [(ngModel)]="infractionDate" (change)="search()" />
          </div>

          <div class="filter-group">
            <label class="form-label">Nº AIT</label>
            <input type="text" class="form-control" [(ngModel)]="aitNumber" placeholder="Ex.: 1234567890"
              (keyup.enter)="search()" />
          </div>

          <div class="filter-group filter-group--period">
            <label class="form-label">Período</label>
            <div class="period-inputs">
              <input type="date" class="form-control" [(ngModel)]="periodStartDate" (change)="search()" />
              <span class="period-separator">até</span>
              <input type="date" class="form-control" [(ngModel)]="periodEndDate" (change)="search()" />
            </div>
          </div>
        </div>

        <div class="filter-actions-row">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>Limpar
          </button>
          <button type="button" class="btn btn-primary" (click)="search()">
            <i class="fas fa-search me-2"></i>Pesquisar
          </button>
        </div>
      </div>

      <!-- Tabela -->
      <div *ngIf="!loading && !error && fines.length > 0" class="table-content mt-3">
        <app-table [title]="tableTitle" [columns]="columns" [data]="fines" [loading]="loading" [showSearch]="showSearch"
          [searchPlaceholder]="searchPlaceholder" [clickable]="clickable" [actions]="actions" [enableSorting]="true"
          [clientSideSort]="true" [totalItemsFromBackend]="totalItems" [currentPageFromBackend]="currentPage"
          [itemsPerPage]="pageSize" [hasNextPageFromBackend]="currentPage < totalPages"
          [hasPreviousPageFromBackend]="currentPage > 1" [enableSorting]="true" (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)" (actionClick)="onActionClick($event)"
          (searchChange)="onSearch($event)">
        </app-table>
      </div>

      <div *ngIf="!loading && !error && fines.length === 0" class="empty-state">
        <i class="fas fa-file-invoice-dollar"></i>
        <h3>Nenhuma multa encontrada</h3>
        <p>Ajuste os filtros e clique em Pesquisar, ou limpe para ver todas as multas.</p>
      </div>

<div *ngIf="error" class="alert alert-danger mt-3" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>{{ error }}
      </div>
      </ng-container>

      <app-traffic-fines-unlinked *ngIf="aba === 'sem-vinculo'"></app-traffic-fines-unlinked>
    </div>

  </div>

  <!-- Detalhe agora usa tela separada -->

  <div *ngIf="showDriverModal" class="driver-modal-backdrop" (click)="onDriverBackdropClick($event)">
    <div class="driver-modal" role="dialog" aria-modal="true" aria-labelledby="driverModalTitle"
      (click)="$event.stopPropagation()">
      <div class="driver-modal-header">
        <div>
          <h2 id="driverModalTitle">
            <i class="fas fa-user-plus me-2"></i>
            {{ existingIndicationId ? 'Editar indicação de condutor' : 'Indicar condutor' }}
          </h2>
          <p>{{ existingIndicationId ? 'Atualize os dados do condutor indicado para esta multa.' : 'Preencha os dados do
            condutor para esta multa.' }}</p>
        </div>

        <button type="button" class="btn-close-details" aria-label="Fechar" (click)="closeDriverModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="driver-modal-body">
        <div *ngIf="driverModalWarning" class="alert alert-warning" role="alert">
          <i class="fas fa-exclamation-circle me-2"></i>{{ driverModalWarning }}
        </div>

        <div *ngIf="driverModalError" class="alert alert-danger" role="alert">
          <i class="fas fa-exclamation-triangle me-2"></i>{{ driverModalError }}
        </div>

        <div *ngIf="driverModalLoading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>

        <ng-container *ngIf="!driverModalLoading">
          <div class="driver-form-grid">
            <div class="driver-form-group">
              <label class="form-label">Nome do Condutor<span class="text-danger">*</span></label>
              <input type="text" class="form-control" name="driverName" [(ngModel)]="driverForm.name" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">CPF<span class="text-danger">*</span></label>
              <input type="text" class="form-control" name="driverCpf" [(ngModel)]="driverForm.cpf" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">RG</label>
              <input type="text" class="form-control" name="driverRg" [(ngModel)]="driverForm.rg" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">Endereço</label>
              <input type="text" class="form-control" name="driverAddress" [(ngModel)]="driverForm.address" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">CEP</label>
              <input type="text" class="form-control" name="driverCep" [(ngModel)]="driverForm.cep" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">Cidade</label>
              <input type="text" class="form-control" name="driverCity" [(ngModel)]="driverForm.city" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">Estado</label>
              <input type="text" class="form-control" name="driverState" [(ngModel)]="driverForm.state" />
            </div>
          </div>

          <div class="driver-form-section-title">Carteira de Habilitação (CNH)</div>
          <div class="driver-form-grid">
            <div class="driver-form-group">
              <label class="form-label">Número da Cédula</label>
              <input type="text" class="form-control" name="driverCnhNumber" [(ngModel)]="driverForm.cnhNumber" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">Número Registro CNH</label>
              <input type="text" class="form-control" name="driverCnhRegister" [(ngModel)]="driverForm.cnhRegister" />
            </div>
            <div class="driver-form-group">
              <label class="form-label">UF da CNH</label>
              <input type="text" class="form-control" name="driverCnhUf" [(ngModel)]="driverForm.cnhUf" maxlength="2"
                style="text-transform: uppercase" />
            </div>
          </div>
        </ng-container>
      </div>

      <div class="driver-modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDriverModal()"
          [disabled]="driverModalLoading || driverDocumentLoading">
          <i class="fas fa-times me-2"></i>
          Cancelar
        </button>
        <button type="button" class="btn btn-success" (click)="generateDriverIndicationDocument()"
          [disabled]="!driverIndicationSaved || driverModalLoading || driverDocumentLoading">
          <span *ngIf="driverDocumentLoading" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          <i *ngIf="!driverDocumentLoading" class="fas fa-file-word me-2"></i>
          Gerar Documento
        </button>
        <button type="button" class="btn btn-primary" (click)="saveDriverIndication()"
          [disabled]="driverModalLoading || driverDocumentLoading || !driverForm.name || !driverForm.cpf">
          <span *ngIf="driverModalLoading" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          {{ existingIndicationId ? 'Atualizar' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de Seleção de Status -->
  <app-modal [isOpen]="showStatusSelectionModal" [title]="'Alterar Status da Multa'" [size]="'md'" [closable]="true"
    (close)="closeStatusModal()">
    <div class="py-3" *ngIf="statusModalSelectedStatus !== 'NIC Não Indicável'">
      <p class="text-muted mb-3" *ngIf="statusModalSelectedFine">
        Selecione o novo status para <strong>{{ statusModalSelectedFine.aipNumber || statusModalSelectedFine.AIPNumber
          || 'multa' }}</strong>.
      </p>

      <div class="status-grid">
        <button type="button" class="traffic-fine-status-option"
          [class.traffic-fine-status-option--selected]="statusModalSelectedStatus === status"
          *ngFor="let status of availableStatuses" (click)="selectStatusFromModal(status)"
          [disabled]="statusModalLoading">
          <i class="fas fa-check me-2" *ngIf="statusModalSelectedStatus === status"></i>
          {{ status }}
        </button>
      </div>
      <div *ngIf="statusModalError" class="alert alert-danger mt-3">{{ statusModalError }}</div>
    </div>
    <div *ngIf="statusModalSelectedStatus === 'NIC Não Indicável'" class="py-3">
      <label>O status da Multa não pode ser alterada por ser <strong>NIC Não Indicável</strong>.</label>
    </div>

    <div slot="footer" class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="closeStatusModal()" [disabled]="statusModalLoading">
        <i class="fas fa-times me-2"></i>
        Fechar
      </button>
    </div>
  </app-modal>

  <app-customer-selection-modal #customerLinkModal (customerSelected)="onCustomerLinked($event)">
  </app-customer-selection-modal>

</app-side-menu>